var map = {
	"./LaserParticle_1.json": [
		604,
		50
	],
	"./LaserParticle_2.json": [
		605,
		51
	],
	"./LaserParticle_3.json": [
		606,
		52
	],
	"./LaserParticle_4.json": [
		607,
		53
	],
	"./LaserParticle_5.json": [
		608,
		54
	],
	"./LaserParticle_6.json": [
		609,
		55
	],
	"./LaserParticle_7.json": [
		610,
		56
	],
	"./Laser_1.json": [
		611,
		57
	],
	"./Laser_2.json": [
		612,
		58
	],
	"./Laser_3.json": [
		613,
		59
	],
	"./Laser_4.json": [
		614,
		60
	],
	"./Laser_5.json": [
		615,
		61
	],
	"./Laser_6.json": [
		616,
		62
	],
	"./Laser_7.json": [
		617,
		63
	],
	"./Laser_8.json": [
		618,
		64
	],
	"./Laser_9.json": [
		619,
		65
	],
	"./Smoke.json": [
		620,
		66
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1173;
module.exports = webpackAsyncContext;